const VoucherType = {
  PesoVoucherCode: "peso-voucher",
  PesoDiscount: "peso-discount-voucher",
  LOCQPayPesoDiscountVoucher: "locq-pay-peso-discount-voucher",
  LOCQPayLubesDiscountVoucher: "locq-pay-lubes-discount-voucher",
  ThirdPartyVoucher: "third-party-voucher",
};

export default VoucherType;
